import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import UrlConfirmation from "./UrlConfirmation";

const ConfirmacionPago = () => {

    const [mostrarInformacion, setMostrarInformacion] = useState(true)

    useEffect(() => {
        debugger
        const urlAnterior = document.referrer
        const validarUrlDesarrollo = UrlConfirmation.urlDesarrollo
        const validarUrlProduccion = UrlConfirmation.urlProduccion
        console.log(urlAnterior)
        if (urlAnterior.trim() === validarUrlDesarrollo || urlAnterior.trim() === validarUrlProduccion){
            setMostrarInformacion(true)
        }
        else{
            setMostrarInformacion(false)
        }
    }, [])

    const location = useLocation();

    const queryParameters = new URLSearchParams(location.search);

    if (mostrarInformacion){
        return (
            <div style={{ width: "85%" }}>
                <h1>
                    Confirmacion Pago
                </h1>
                <div>
                <table style={{ width: "100%" }}>
                    <thead>
                        <tr style={{ backgroundColor: "#F0F0F0" }}>
                            <td colSpan="2" style={{ padding: "10px", fontWeight: "bold" }}>
                                <span>
                                    Resultado de la transacción
                                </span>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ padding: "5px 10px", width: "35%" }}>Empresa:</td>
                            <td style={{ padding: "5px 10px" }}>{queryParameters.get("enterprise")}</td>
                        </tr>
                        <tr>
                            <td style={{ padding: "5px 10px", width: "35%" }}>NIT:</td>
                            <td style={{ padding: "5px 10px" }}>{queryParameters.get("nit")}</td>
                        </tr>
                        <tr>
                            <td style={{ padding: "5px 10px", width: "35%" }}>Fecha:</td>
                            <td style={{ padding: "5px 10px" }}>{queryParameters.get("processingDate")}</td>
                        </tr>
                        <tr>
                            <td style={{ padding: "5px 10px", width: "35%" }}>Estado:</td>
                            <td style={{ padding: "5px 10px" }}>{queryParameters.get("message")}</td>
                        </tr>
                        <tr>
                            <td style={{ padding: "5px 10px", width: "35%" }}>Referencia de pedido:</td>
                            <td style={{ padding: "5px 10px" }}>{queryParameters.get("referenceCode")}</td>
                        </tr>
                        <tr>
                            <td style={{ padding: "5px 10px", width: "35%" }}>Referencia transacción:</td>
                            <td style={{ padding: "5px 10px" }}>{queryParameters.get("transactionId")}</td>
                        </tr>
                        <tr>
                            <td style={{ padding: "5px 10px", width: "35%" }}>Número transacción:</td>
                            <td style={{ padding: "5px 10px" }}>{queryParameters.get("cus")}</td>
                        </tr>
                        <tr>
                            <td style={{ padding: "5px 10px", width: "35%" }}>Banco:</td>
                            <td style={{ padding: "5px 10px" }}>{queryParameters.get("pseBank")}</td>
                        </tr>
                        <tr>
                            <td style={{ padding: "5px 10px", width: "35%" }}>Valor:</td>
                            <td style={{ padding: "5px 10px" }}>{queryParameters.get("TX_VALUE")}</td>
                        </tr>
                        <tr>
                            <td style={{ padding: "5px 10px", width: "35%" }}>Moneda:</td>
                            <td style={{ padding: "5px 10px" }}>{queryParameters.get("currency")}</td>
                        </tr>
                        <tr>
                            <td style={{ padding: "5px 10px", width: "35%" }}>Descripcion:</td>
                            <td style={{ padding: "5px 10px" }}>{queryParameters.get("description")}</td>
                        </tr>
                        <tr>
                            <td style={{ padding: "5px 10px", width: "35%" }}>Ip origen:</td>
                            <td style={{ padding: "5px 10px" }}>{queryParameters.get("pseReference1")}</td>
                        </tr>
                    </tbody>
                </table>
                </div>
            </div>
        )
    }
    else {
        return (
            <div style={{ width: "85%" }}>
            <h1>
                Confirmacion Pago
            </h1>
            <div>
            <table style={{ width: "100%" }}>
                <thead>
                    <tr style={{ backgroundColor: "#F0F0F0" }}>
                        <td style={{ padding: "10px", fontWeight: "bold" }}>
                            <span>
                                Resultado de la transacción
                            </span>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={{ padding: "5px 10px", width: "35%" }}>No se accedio de manera correcta a la información.</td>
                    </tr>
                </tbody>
            </table>
            </div>
        </div>
        )
    }
}

export default ConfirmacionPago;